// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lSoiX","option":"styles_option__2zqD6","active":"styles_active__6BQPC"};